import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { useState } from "react";

const categories = [
  "All",
  "Recipes",
  "Tips & Tricks",
  "Healthy",
  "Chef Stories",
];
export default function BlogCategories({ onCategorySelect }) {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const onSelectCategory = (category) => {
    setSelectedCategory(category);
    onCategorySelect(category);
  };

  return (
    <List
      sx={{
        maxWidth: 250,
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Typography
        variant="h6"
        sx={{ p: 2, textAlign: "center", fontWeight: "bold" }}
      >
        Blog Categories
      </Typography>
      {categories.map((category) => (
        <ListItem key={category}>
          <ListItemButton
            key={category}
            selected={selectedCategory === category}
            onClick={() => onSelectCategory(category)}
          >
            <ListItemText>{category}</ListItemText>
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
}
